import { BabaMainProduct } from './BundleProduct/main';
import { StyledBabaBundle } from './style';
import { BundleProps, ProductData } from 'utils/types';
import { Box, Stack } from '@mui/material';
import { EProductPriority, EProductType } from 'utils/enums';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useEffect, useRef, useState } from 'react';
import { moveProductGrid } from 'utils';
import { BabaSaleBadge } from 'components/Badge/Sale/BabaSaleBadge';
import { BabaBundlePrice } from './BundlePrice';
import { babaUtils } from './utils';
import { SubProductsContainer } from './BundleProduct/SubProductsContainer';

export const BabaBundle: React.FC<BundleProps> = ({
  backgroundSrc,
  price = {
    price: 100,
    currencySymbol: '$',
    isCents: true,
    symbolPosition: 'right',
    fractionalSeparator: '.',
    milSeparator: ',',
    spacing: false,
    currencyCode: 'usd',
    multiplier: 100,
  },
  productList = [
    {
      textFontColorHex: '#ffabff',
      images: {
        product:
          'https://media-staging.appcharge.com/media/66f2b3c0fea2a56ff9086cdb/1728496419194__72a770cd-2bd1-4815-aedf-d1e401424dc8',
      },
      quantity: 100,
      prefix: '',
      suffix: '',
      priority: EProductPriority.MAIN,
      quantityDisplay: '100',
      productType: EProductType.QUANTITY,
      publisherProductId: '',
    },
  ],
  bundleButtonColor,
  bundleButtonTextColor,
  salePercentage = 0,
  bundleRef,
  inMobileMock = false,
  loaded,
}) => {
  const subItemsGrid = useRef<HTMLDivElement>(null);
  const [isDoneScrolling, setIsDoneScrolling] = useState(false);
  const [showScroller, setShowScroller] = useState(false);
  const [mainProduct, setMainProduct] = useState<ProductData | null>(null);
  const [subProductsSplit, setSubProductsSplit] = useState<ProductData[][]>([]);

  useEffect(() => {
    if (!productList || productList.length === 0) return;

    const main = productList.find(
      (product) => product.priority === EProductPriority.MAIN,
    );
    setMainProduct(main!);

    const arrSubProducts = productList.filter(
      (product) => product.priority === EProductPriority.SUB,
    );

    setSubProductsSplit(babaUtils.splitSubProductsArray(arrSubProducts));
  }, [productList]);

  const moveGrid = (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e?.stopPropagation();

    const subItemsGridElement = subItemsGrid?.current;
    if (subItemsGridElement as HTMLDivElement) {
      moveProductGrid({
        subItemsGridElement: subItemsGridElement as HTMLDivElement,
        isDoneScrolling,
        setIsDoneScrolling,
        distance: (subItemsGridElement as HTMLDivElement).clientWidth,
      });
    }
  };

  useEffect(() => {
    const shouldShowScrollbar = () => {
      setShowScroller(
        subItemsGrid?.current
          ? subItemsGrid?.current?.scrollWidth >
              subItemsGrid?.current?.clientWidth
          : false,
      );
    };

    shouldShowScrollbar();

    window.addEventListener('resize', shouldShowScrollbar);

    return () => {
      window.removeEventListener('resize', shouldShowScrollbar);
    };
  }, [subItemsGrid.current, loaded, subProductsSplit]);

  return (
    <StyledBabaBundle
      backgroundSrc={backgroundSrc}
      className={'baba-bundle' + (inMobileMock ? ' bundle--iphone-mock' : '')}
      ref={bundleRef}
    >
      <Box className="container" gap="8px">
        {salePercentage > 0 && (
          <BabaSaleBadge salePercentage={salePercentage} />
        )}
        {productList.length > 0 ? (
          <Box className="products">
            {showScroller && (
              <Stack className="scroller">
                <button onClick={(e) => moveGrid(e)}>
                  {isDoneScrolling ? (
                    <ArrowBackIosNewIcon
                      sx={{
                        color: 'white',
                        fontSize: 16,
                      }}
                    />
                  ) : (
                    <ArrowForwardIosIcon
                      sx={{
                        color: 'white',
                        fontSize: 16,
                      }}
                    />
                  )}
                </button>
              </Stack>
            )}
            <BabaMainProduct
              quantityDisplay={mainProduct?.quantityDisplay}
              strokedSaleQuantity={mainProduct?.strokedSaleQuantity}
              image={mainProduct?.images?.product}
              salePercentage={salePercentage}
            />
            <SubProductsContainer
              subItemsGridRef={subItemsGrid}
              subProductsSplit={subProductsSplit}
            />
          </Box>
        ) : (
          <Box className="products" style={{ height: '214px' }}></Box>
        )}
        <BabaBundlePrice
          price={price}
          bundleButtonColor={bundleButtonColor}
          bundleButtonTextColor={bundleButtonTextColor}
        />
      </Box>
    </StyledBabaBundle>
  );
};
